import script from "./purchaselist.vue?vue&type=script&setup=true&lang=js"
export * from "./purchaselist.vue?vue&type=script&setup=true&lang=js"

import "./purchaselist.vue?vue&type=style&index=0&id=3595c9d1&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3595c9d1"]])

export default __exports__